
import type { PropType } from 'vue';

import { defineComponent } from 'vue';

import type { GenericObject } from '@/types';

export default defineComponent({
  props: {
    handler: {
      type: Function as PropType<(name: string, key: string, filters: GenericObject) => void>,
      required: true,
    },
    subStatisticsComponentKey: {
      type: String,
      required: true,
    },
    filters: {
      type: Object as PropType<GenericObject>,
      default: () => ({}),
    },
  },
});
